import React from 'react';
import { useOnlineStatus } from '@/shared/hooks/useOnlineStatus';
import { useTranslation } from '@/shared/i18n';
import { Icon } from '@/design-system/primitives';

export const OfflineBanner: React.FC = () => {
  const isOnline = useOnlineStatus();
  const { t } = useTranslation();

  if (isOnline) return null;

  return (
    <div className="bg-amber-500 text-white text-sm text-center py-2 px-4 flex items-center justify-center gap-2">
      <Icon name="Wifi" size={16} />
      <span>{t('common.offlineMode', 'Mode hors ligne — les donn\u00e9es affich\u00e9es peuvent ne pas \u00eatre \u00e0 jour')}</span>
    </div>
  );
};
